import React from "react";
import classNames from "classnames";
import {KeyValue} from "../../../stores/observables/keyValue";
import "./switcher.sass";
import {observer} from "mobx-react-lite";
import {ObservableList} from "../../../stores/observables/observableList";
import {runInAction} from "mobx";

export interface ISwitcherProps {
  options: ObservableList<KeyValue>;
  onClick?: (item: KeyValue) => void;
}

const Switcher: React.FC<ISwitcherProps> = ({options, onClick}) => {
  const handleClick = (item: KeyValue) => {
    runInAction(() => {
      options.selectedItem = item;
    });
    onClick?.(item);
  };
  return (
    <div className="switcher">
      {options.items &&
        options.items.map((item) => (
          <div
            key={item.value}
            className={classNames({selected: options.selectedItem === item})}
            onClick={() => handleClick(item)}
          >
            {item.label}
          </div>
        ))}
    </div>
  );
};

export default observer(Switcher);
